<template>
  <section id="factor-payment">
    <div class="container">
      <div class="row ml-5">
        <div class="col-md-1 mt-5 mx-auto">
          <div class="text-center">
            <img
              :src="currentLogo"
              alt=""
              width="80px"
            />
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center mx-0" v-if="payment_details">
        <div
            class="col-12 col-md-8 p-1 pb-sm-3 pt-sm-2 mt-3"
            :style="payment_details.payment_status == 1 ? 'background-color: green;' : 'background-color: red;'"
            id="cardPaymentData"
        >
          <div class="text-center mb-3 mt-1">
            <span>{{ payment_details.payment_status == 1 ? 'پرداخت موفق' : 'پرداخت ناموفق' }}</span>
          </div>
          <div class="d-flex flex-column flex-md-row p-2 p-md-0 justify-content-between mx-md-5">
            <div class="d-flex align-items-center justify-content-between justify-content-md-center mx-1">
              <span>کد رهگیری:</span>
              <span class="mx-2 en_num">{{ payment_details.tracking_number }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between justify-content-md-center mx-1">
              <span>نام پرداخت کننده:</span>
              <span class="mx-2">{{ payment_details.customer_name }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between justify-content-md-center mx-1">
              <span>تاریخ پرداخت:</span>
              <span dir="ltr" class="mx-2">{{ payment_details.payment_date }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-8 mx-auto py-4 mb-5">
          <div class="card bg-white p-4 factor-payment-bg-white" id="cardPaymentData">
            <div class="text-center">
              <div class="container" v-if="payDetails.payment_status == '2'">
                <div class="row">
                  <div class="col-md-6 mx-auto">
                    <img
                      src="@/assets/media/paid_stamp.png"
                      alt="Paid_Stamp"
                      width="120px"
                    />
                  </div>
                </div>
              </div>
              <div class="container" v-if="payDetails.payment_status == '1'">
                <div class="row">
                  <div class="col-md-6 mx-auto">
                    <img
                      src="@/assets/media/canceled_stamp.jpg"
                      alt="Canceled_Stamp"
                      width="150px"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3 mx-5 mb-4">
              <div class="ml-5">
                <p>تاریخ فاکتور</p>
                <span v-if="payDetails.sending_date">{{ payDetails.sending_date }} </span>
                <span v-else-if="payDetails.type == '3'" >{{ payDetails.created_at }}</span>
                <span v-else>______</span>
              </div>
              <div class="flex-column justify-content-center align-items-center">
                <p>شماره فاکتور</p>
                <span v-if="payDetails.code">{{ payDetails.code }}</span>
                <span v-else>______</span>
              </div>
            </div>
            <div
              class="d-flex flex-row align-items-center justify-content-center c_pointer"
              id="personal_info"
            >
              <div v-if="payDetails.customer">
                <img
                  v-if="payDetails.customer.image"
                  :src="`${payDetails.customer.image}`"
                  style="width: 100px; border-radius: 50%"
                  alt=""
                />
                <img
                    v-else
                    src="../../../assets/media/defaultCustomer.jpeg"
                    style="width: 100px; border-radius: 50%"
                    alt=""
                />
              </div>
            </div>
            <!-- Customer Name -->
            <div>
              <div v-if="payDetails.customer" class="text-center mt-4">
                <h5 class="text-dark font-weight-bold">{{ payDetails.customer.name }}</h5>
              </div>
              <hr />
              <div class="text-center mt-4">
                <h5 class="text-dark font-weight-bold">{{ payDetails.title }}</h5>
              </div>
            </div>
            <div v-if="payDetails.format && !payDetails.customer" class="my-3 mt-3 w-100">
              <!--String-->
              <div class="mb-3 d-flex flex-wrap">
                <StringInput
                    v-if="string_fields.length > 0"
                    v-for="field in string_fields"
                    :key="field.id"
                    :field="field"
                    :customer_style="true"
                    @validate="handleValidation"
                />
                <NumericInput
                    v-if="numeric_fields.length > 0"
                    v-for="field in numeric_fields"
                    :key="field.id"
                    :field="field"
                    :customer_style="true"
                    @validate="handleValidation"
                />
                <DateInput
                    v-if="date_fields.length > 0"
                    v-for="field in date_fields"
                    :key="field.id"
                    :field="field"
                    :customer_style="true"
                    @validate="handleValidation"
                />
                <SelectInput
                    v-if="select_fields.length > 0"
                    v-for="field in select_fields"
                    :key="field.id"
                    :field="field"
                    :customer_style="true"
                    @validate="handleValidation"
                />
                <TextInput
                    v-if="text_fields.length > 0"
                    v-for="field in text_fields"
                    :key="field.id"
                    :field="field"
                    :customer_style="true"
                    @validate="handleValidation"
                />
              </div>
            </div>
            <div
                v-if="payDetails.customer"
                class="my-4"
            >
              <div class="d-flex justify-content-center align-items-center text-nowrap w-100 text-dark row mx-auto">
                <div v-if="payDetails.customer.name"
                     class="d-flex flex-column justify-content-between w-100 col-12 col-md-4"
                     style="padding-left: 0; padding-right: 0"
                >
                  <label class="p-2 py-3 text-center" style="background-color: #E9ECEF">نام و نام خانوادگی</label>
                  <p class="px-1 py-2 text-center">{{ payDetails.customer.name }}</p>
                </div>
                <div v-if="payDetails.customer.mobile"
                     class="d-flex flex-column justify-content-between w-100 col-12 col-md-4"
                     style="padding-left: 0; padding-right: 0"
                >
                  <label class="p-2 py-3 text-center" style="background-color: #E9ECEF">موبایل</label>
                  <p dir="ltr" class="px-1 py-2 text-center">{{ payDetails.customer.mobile }}</p>
                </div>
                <div v-if="payDetails.customer.email"
                     class="d-flex flex-column justify-content-between w-100 col-12 col-md-4"
                     style="padding-left: 0; padding-right: 0"
                >
                  <label class="p-2 py-3 text-center" style="background-color: #E9ECEF">ایمیل</label>
                  <p class="px-1 py-2 text-center">{{ payDetails.customer.email }}</p>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div>
              <table class="table">
                <thead class="thead-light text-center">
                  <tr>
                    <th colspan="2">آیتم</th>
                    <th>تعداد</th>
                    <th>مبلغ آیتم</th>
                    <th>مجموع</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in payDetails.items"
                    :key="(item, idx)"
                    class="my-3"
                  >
                    <td colspan="2" class="text-dark">{{ item.title }}</td>
                    <td class="text-dark d-flex align-items-center justify-content-between">
                      <div v-if="item.quantity_selection && !sub_factor_id">
                        <div
                            class="btn-sm text-primary"
                            @click="increase(item, idx)"
                            style="text-align: center; cursor: pointer"
                        >
                          <i class="fa fa-plus"></i>
                        </div>
                      </div>
                      <div class="text-center w-100">
                        {{ item.number }}
                      </div>
                      <div v-if="item.quantity_selection && !sub_factor_id">
                        <div
                            class="btn-sm text-primary"
                            @click="decrease(item, idx)"
                            style="text-align: center; cursor: pointer"
                        >
                          <i class="fa fa-minus"></i>
                        </div>
                      </div>
                    </td>
                    <td class="text-dark">{{ item.unit_amount.toLocaleString() + ' ریال' }}</td>
                    <td class="text-dark">{{ item.final_amount.toLocaleString() + ' ریال' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Details Factor -->
            <div class="row mx-2">
              <div class="col-md-6 my-5 text-center">
                <qrcode-vue :value="payDetails.url" :size="size" level="M" />
                <div class="bg-light p-4 my-2" v-if="payDetails.message">
                  <span>پیغام : </span>
                  <span>{{ payDetails.message }}</span>
                </div>
                <div class="bg-light p-4 my-2" v-if="payDetails.rules && payDetails.payment_status == 2">
                  <span>توضیحات : </span>
                  <span>{{ payDetails.rules }}</span>
                </div>
                <div class="bg-light p-4 my-2" v-if="payDetails.receipt_link && payDetails.payment_status == 2">
                  <span>لینک رسید : </span>
                  <button class="btn btn-primary">
                      <a target="_blank" :href="payDetails.receipt_link">
                        <span>{{ payDetails.receipt_link }}</span>
                      </a>
                  </button>
                </div>
              </div>
              <div class="col-md-6 my-5">
                <div class="d-flex align-items-start justify-content-between">
                  <h5>قیمت کل محصولات</h5>
                  <p>{{ amount.toLocaleString() + ' ریال' }}</p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5>هزینه حمل و نقل</h5>
                  <p>{{ payDetails.shipping_cost.toLocaleString() + ' ریال' }}</p>
                </div>
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <h5>مجموع تخفیف</h5>
                  <p>{{ discount.toLocaleString() + ' ریال' }}</p>
                </div>
<!--                <hr v-if="payDetails.wage" />-->
<!--                <div v-if="payDetails.wage" class="d-flex align-items-start justify-content-between">-->
<!--                  <h5>کارمزد درگاه بانکی</h5>-->
<!--                  <p>{{ payDetails.wage.toLocaleString() + ' ریال' }}</p>-->
<!--                </div>-->
                <hr />
                <div class="d-flex align-items-start justify-content-between">
                  <div class="d-flex">
                    <h5>مبلغ</h5>
                    <p class="text-tiny mx-1">(بدون احتساب کارمزد درگاه)</p>
                  </div>
                  <p class="text-primary font-weight-bold">
                    {{ payment_amount.toLocaleString() + ' ریال' }}
                  </p>
                </div>
                <div
                    v-if="payment_details && payment_details.payment_status == 1"
                    class="d-flex align-items-start justify-content-between"
                >
                  <div class="d-flex">
                    <h5>کارمزد درگاه</h5>
                  </div>
                  <p class="text-primary font-weight-bold">
                    {{ (payment_details.wage + payment_details.wage_bank - (payment_details.merchant_wage_share + payment_details.merchant_share_wage_bank)).toLocaleString() + ' ریال' }}
                  </p>
                </div>
<!--                <div-->
<!--                    v-if="payment_details && payment_details.payment_status == 1"-->
<!--                    class="d-flex align-items-start justify-content-between"-->
<!--                >-->
<!--                  <div class="d-flex">-->
<!--                    <h5>کارمزد بانک</h5>-->
<!--                  </div>-->
<!--                  <p class="text-primary font-weight-bold">-->
<!--                    {{ payment_details.wage_bank.toLocaleString() + ' ریال' }}-->
<!--                  </p>-->
<!--                </div>-->
                <div
                    v-if="payment_details && payment_details.payment_status == 1"
                    class="d-flex align-items-start justify-content-between"
                >
                  <div class="d-flex">
                    <h5>مبلغ پرداخت شده</h5>
                  </div>
                  <p class="text-primary font-weight-bold">
                    {{ (payment_amount + payment_details.wage + payment_details.wage_bank - (payment_details.merchant_wage_share + payment_details.merchant_share_wage_bank)).toLocaleString() + ' ریال' }}
                  </p>
                </div>
                <!--Discount Code-->
                <div v-if="!sub_factor_id" class="d-flex justify-content-between my-4 ">
                  <input class="form-control light-input w-75" v-model="discount_code" type="text" style="text-transform: uppercase;">
                  <button :disabled="!discount_code" id="discount-btn" @click="applyCode" class="btn btn-secondary">ثبت کد</button>
                </div>
              </div>
            </div>
            <!-- Button -->
            <div class="d-flex justify-content-center">
              <button
                id="review-payment"
                class="btn btn-primary text-white col-md-6 c_pointer"
                :class="is_repayment ? 'btn-success' : 'btn-primary'"
                @click="reviewPayment()"
                :disabled="!payBtn"
              >
                {{ is_repayment ? 'پرداخت مجدد' : 'پرداخت' }}
              </button>
              <button
                v-if="sub_factor_id != undefined"
                class="btn btn-light text-danger col-md-6 c_pointer"
                @click="cancelFactor()"
                :disabled="!payBtn"
              >
                لغو پرداخت
              </button>
            </div>
            <div
              class="mt-4 w-100 d-flex align-item-center justify-content-center c_pointer"
            >
              <div
                class="text-center c_pointer w-100"
                data-toggle="tooltip"
                data-placement="top"
                title="نسخه پرینت"
              >
                <p @click="printFactor()">
                  <img src="../../../assets/media/print.png" alt="Print" />
                </p>
              </div>
              <div
                @click="generateReport()"
                class="text-center w-100 c_pointer"
                data-toggle="tooltip"
                data-placement="top"
                title="نسخه پی دی اف"
              >
                <img
                  src="../../../assets/media/document.png"
                  alt="GeneratePdf"
                />
              </div>
            </div>
            <div>
              <vue-html2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="true"
                :paginate-elements-by-height="1400"
                filename="Factor Payment"
                :pdf-quality="2"
                :manual-pagination="false"
                pdf-format="a4"
                pdf-orientation="landscape"
                pdf-content-width="800px"
                @progress="onProgress($event)"
                @hasStartedGeneration="hasStartedGeneration()"
                @hasGenerated="hasGenerated($event)"
                ref="html2Pdf"
                name="test"
              >
                <section slot="pdf-content">
                  <!-- PDF Content Here -->
                  <div class="container" v-if="payDetails.payment_status == '2'">
                    <div class="row">
                      <div class="col-md-6">
                        <img
                          src="@/assets/media/paid_stamp.png"
                          alt=""
                          style="position: absolute; top: 50px; left: -550px"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="container" v-if="payDetails.payment_status == '1'">
                    <div class="row">
                      <div class="col-md-6">
                        <img
                          src="@/assets/media/canceled_stamp.jpg"
                          alt=""
                          style="position: absolute; top: 50px; left: -550px"
                          width="300px"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="text-center mt-4">
                          <h5 class="text-dark font-weight-bold">
                            {{ payDetails.title }}
                          </h5>
                        </div>
                        <div
                          class="d-flex flex-row align-items-center justify-content-between"
                        >
                          <div v-if="payDetails.customer" class="d-flex flex-column text-dark my-3">
                            <h5>{{ payDetails.customer.name }}</h5>
                            <p dir="ltr">{{ payDetails.customer.mobile }}</p>
                            <p>{{ payDetails.customer.email }}</p>
                          </div>
                          <div class="d-flex">
                            <div class="mr-5">
                              <p>تاریخ فاکتور</p>
                              <span>{{ payDetails.sending_date }} </span>
                            </div>
                            <div>
                              <p>شماره فاکتور</p>
                              <span> {{ payDetails.code }}</span>
                            </div>
                          </div>
                        </div>
                        <!-- Table -->
                        <table class="table">
                          <thead class="thead-light text-center">
                            <tr>
                              <th>آیتم</th>
                              <th>تعداد</th>
                              <th>مبلغ آیتم</th>
                              <th>مبلغ قابل پرداخت</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, idx) in payDetails.items"
                              :key="(item, idx)"
                            >
                              <td>{{ item.title }}</td>
                              <td>{{ item.number }}</td>
                              <td>{{ item.unit_amount.toLocaleString() + ' ریال' }}</td>
                              <td>{{ item.total_amount.toLocaleString() + ' ریال' }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- Details Factor -->
                        <div class="row">
                          <div class="col-md-6 my-5 text-center">
                            <qrcode-vue :value="payDetails.url" :size="size" level="M" />
                            <div
                              class="bg-light p-4 my-2"
                              v-if="payDetails.message != null"
                            >
                              <span>پیغام : </span>
                              <span>{{ payDetails.message }}</span>
                            </div>
                            <div
                              class="bg-light p-4 my-2"
                              v-if="payDetails.rules != null"
                            >
                              <span>توضیحات : </span>
                              <span>{{ payDetails.rules }}</span>
                            </div>
                          </div>
                          <div class="col-md-6 my-5">
                            <div class="d-flex align-items-start justify-content-between">
                              <h5>قیمت کل محصولات</h5>
                              <p>{{ amount.toLocaleString() + ' ریال' }}</p>
                            </div>
                            <hr />
                            <div class="d-flex align-items-start justify-content-between">
                              <h5>هزینه حمل و نقل</h5>
                              <p>{{ payDetails.shipping_cost.toLocaleString() + ' ریال' }}</p>
                            </div>
                            <hr />
                            <div class="d-flex align-items-start justify-content-between">
                              <h5>مجموع تخفیف</h5>
                              <p>{{ discount.toLocaleString() + ' ریال' }}</p>
                            </div>
<!--                            <hr v-if="payDetails.wage" />-->
<!--                            <div v-if="payDetails.wage" class="d-flex align-items-start justify-content-between">-->
<!--                              <h5>کارمزد درگاه بانکی</h5>-->
<!--                              <p>{{ payDetails.wage.toLocaleString() + ' ریال' }}</p>-->
<!--                            </div>-->
                            <hr />
                            <div class="d-flex align-items-start justify-content-between">
                              <div class="d-flex">
                                <h5>مبلغ</h5>
                                <p class="text-tiny mx-1">(بدون احتساب کارمزد درگاه)</p>
                              </div>
                              <p class="text-primary font-weight-bold">
                                {{ payment_amount.toLocaleString() + ' ریال' }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </vue-html2pdf>
            </div>
          </div>
        </div>
      </div>
      <!--Modal-->
      <ReviewPayment
          @payment="payMoney"
          @close-modal="closeModal"
          v-if="isModalVisible"
          :isVisible="reviewPayment"
          :data="modal_fields"
      />
    </div>
  </section>
</template>

<script>
import { onlineFactorService } from '@/common/shop.service';
import QrcodeVue from 'qrcode.vue';
import toastr from 'toastr';
import VueHtml2pdf from 'vue-html2pdf';
import DateInput from '@/views/online-factor/components/DateInput.vue';
import SelectInput from '@/views/online-factor/components/SelectInput.vue';
import StringInput from '@/views/online-factor/components/StringInput.vue';
import NumericInput from '@/views/online-factor/components/NumericInput.vue';
import TextInput from '@/views/online-factor/components/TextInput.vue';
import { fieldTypesConstants } from '@/constants/CustomerFormatFieldType';
import { fieldOptionsConstants } from '@/constants/CustomerFormatFieldsOptions';
import ReviewPayment from '@/views/online-factor/components/ReviewPayment.vue';
import { KTApp } from '@/plugins/core/app';
import $ from 'jquery';
export default {
  name: 'factorpayment',
  data() {
    return {
      payDetails: {
        items: [],
        wage: 0,
        shipping_cost: 0,
        discount_amount: 0
      },
      discount_id: null,
      size: 100,
      locHref: window.location.href,
      payBtn: null,
      isValid: false,
      modal_fields: {},
      isModalVisible: false,
      sub_factor_id: this.$route.params.subFactorId,
      discount_code: null,
      factor_id: this.$route.params.hashid,
      payment_id: this.$route.query.payment,
      min_purchase_amount: null,
      max_discount_amount: null,
      payment_details: null,
      currentTheme: 'light'
    };
  },
  components: {
    ReviewPayment,
    TextInput, NumericInput, StringInput, SelectInput, DateInput,
    QrcodeVue,
    VueHtml2pdf
  },
  computed: {
    currentLogo() {
      return this.currentTheme === 'dark'
        ? require('@/assets/new/image/logo_new_light.png')
        : require('@/assets/new/image/logo_new_dark.png');
    },
    fieldStatus(){
      return fieldOptionsConstants;
    },
    fieldTypes() {
      return fieldTypesConstants;
    },
    string_fields() {
      if (this.payDetails.format) {
        return this.payDetails.format.fields.filter(item => item.type == this.fieldTypes.STRING);
      }
      return [];
    },
    numeric_fields() {
      if (this.payDetails.format) {
        return this.payDetails.format.fields.filter(item => item.type == this.fieldTypes.NUMERIC);
      }
      return [];
    },
    text_fields() {
      if (this.payDetails.format) {
        return this.payDetails.format.fields.filter(item => item.type == this.fieldTypes.TEXT);
      }
      return [];
    },
    date_fields() {
      if (this.payDetails.format) {
        return this.payDetails.format.fields.filter(item => item.type == this.fieldTypes.DATE);
      }
      return [];
    },
    select_fields() {
      if (this.payDetails.format) {
        return this.payDetails.format.fields.filter(item => item.type == this.fieldTypes.SELECT);
      }
      return [];
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: 'toast-bottom-center',
        preventDuplicates: false,
        rtl: false
      };
      return toastr;
    },
    discount() {
      let discount = (this.payDetails.discount_amount || 0)
          + ((this.payDetails.discount_percent || 0) / 100 * (this.amount + this.payDetails.shipping_cost))

      if (this.min_purchase_amount && (this.amount + this.payDetails.shipping_cost) < this.min_purchase_amount) {
        discount = 0
      }

      if (this.max_discount_amount && discount > this.max_discount_amount) {
        discount = this.max_discount_amount
      }

      return discount || 0
    },
    payment_amount() {
      return this.amount + this.payDetails.shipping_cost - this.discount
    },
    amount() {
     return this.payDetails.items.reduce((accumulator, item) => {
        return accumulator + (item.final_amount || 0);
      }, 0);
    },
    is_repayment() {
      let value = this.payment_details && this.payment_details.payment_status != 1
      if (value) {
        this.toastr.error('پرداخت فاکتور ناموفق بود!')
      }
      return value
    },
  },
  methods: {
    applyCode() {
      let btn = $('#discount-btn')
      KTApp.progress(btn)
      onlineFactorService.applyDiscount(this.discount_code.toUpperCase(), this.factor_id)
          .then(response => {
              this.payDetails.discount_percent = response.data.data.discount_percent
              this.min_purchase_amount = response.data.data.min_purchase_amount
              this.max_discount_amount = response.data.data.max_discount_amount
              this.discount_id = response.data.data.id

              if ((this.amount + this.payDetails.shipping_cost) < this.min_purchase_amount) {
                return this.toastr.error(`حداقل مبلغ خرید برای این کد تخفیف ${this.min_purchase_amount.toLocaleString()} میباشد`)
              }
              return this.toastr.success(response.data.message)
          })
          .catch(({response}) => {
            return this.toastr.error(response.data.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    },
    increase(item, idx) {
      if (item.quantity - (item.number + 1) < 0 && !item.is_unlimited) {
        return this.toastr.error(`موجودی محصول << ${item.title} >> کافی نمی باشد.`)
      }

      this.payDetails.items[idx].number++;
      this.calItemPrice(idx)
    },
    decrease(item, idx) {
      if (this.payDetails.items[idx].number == 1) {
        return;
      }
      this.payDetails.items[idx].number--;
      this.calItemPrice(idx)
    },
    calItemPrice(id) {
      if (this.payDetails.items[id].final_amount - this.payDetails.items[id].total_amount != 0) {
        this.payDetails.items[id].final_amount =
            (this.payDetails.items[id].unit_amount * this.payDetails.items[id].number)
            +
            (this.payDetails.items[id].unit_amount * this.payDetails.items[id].number) * 0.09;
      } else {
        this.payDetails.items[id].final_amount = this.payDetails.items[id].unit_amount * this.payDetails.items[id].number
      }
      this.payDetails.items[id].total_amount = this.payDetails.items[id].unit_amount * this.payDetails.items[id].number;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleValidation({ fieldId, isValid}) {
      const fields = [
        ...this.string_fields,
        ...this.numeric_fields,
        ...this.date_fields,
        ...this.select_fields,
        ...this.text_fields
      ];
      const field = fields.find(f => f.id == fieldId);

      if (field) {
        field.error = !isValid;
      }

      this.isValid = fields.every(f => f.error == false);
    },
    printFactor() {
      window.print();
    },
    validateAllFields() {
      const fields = [
        ...this.string_fields,
        ...this.numeric_fields,
        ...this.date_fields,
        ...this.select_fields,
        ...this.text_fields
      ];

      // Trigger validation for each field
      fields.forEach(field => {
        if (field.status == this.fieldStatus.REQUIRED && !field.value) {
          field.error = true;
        } else {
          field.error = false;
        }
      });
    },
    async reviewPayment() {
      let btn = $('#review-payment')

      if (!this.isValid && this.payDetails.type == '3' && !this.$route.params.subFactorId) {
        this.toastr.error('اطلاعات وارد شده نامتعبر می باشد.');
        return;
      }

      KTApp.progress(btn)

      if (this.payDetails.type == '3' && !this.$route.params.subFactorId) {
        let fields = [
          ...this.string_fields,
          ...this.numeric_fields,
          ...this.date_fields,
          ...this.select_fields,
          ...this.text_fields
        ];

        this.modal_fields.fields = fields.map(item => ({
          name: item.name,
          fa_name: item.fa_name,
          value: item.value,
          status: item.status,
          type: item.type
        }));

        let params = {
          items: this.payDetails.items.map(item => ({
            id: item.id,
            number: item.number,
          }))
        }
        if (this.discount_id)
          params.discount_id = this.discount_id


        await onlineFactorService.reviewPayment(this.factor_id, params)
            .then(response => {
              this.payDetails.wage = response.data.data.wage_amount
            })
      }

      this.modal_fields.items = this.payDetails.items;
      this.modal_fields.amount = this.amount;
      this.modal_fields.shipping_cost = this.payDetails.shipping_cost;
      this.modal_fields.discount_amount = this.discount;
      this.modal_fields.wage = this.payDetails.wage;
      this.modal_fields.payment_amount = this.payment_amount;
      this.isModalVisible = true;
      KTApp.unprogress(btn)
    },
    payMoney() {
      KTApp.progress($('#payment-btn'));

      let params = {
        sub_factor_id: this.$route.params.subFactorId || ''
      };
      if (this.payDetails.type == '3' && !this.sub_factor_id) {
        let fields = [
          ...this.string_fields,
          ...this.numeric_fields,
          ...this.date_fields,
          ...this.select_fields,
          ...this.text_fields
        ];

        fields = fields.map(field => ({
          id: field.id,
          name: field.name,
          fa_name: field.fa_name,
          value: field.value,
          status: field.status,
          type: field.type
        }));

        params.fields = fields;
        params.items = this.payDetails.items.map(item => ({
          id: item.id,
          number: item.number
        }))

        if (this.discount_id)
          params.discount_id = this.discount_id
      }

      onlineFactorService
        .payMoneyFactor(this.$route.params.hashid, params)
        .then((response) => {
          window.location.href = response.data;
        })
        .catch(({ response }) => {
          for (let err in response.data.data) {
            this.toastr.error(response.data.data[err]);
          }
          return this.toastr.error(response.data.message);
        })
        .finally(() => {
          KTApp.unprogress($('#payment-btn'));
        });
    },
    cancelFactor() {
      onlineFactorService
        .cancelFactor(this.$route.params.subFactorId)
        .then((response) => {
          window.location.reload();
          toastr.info(response.data.message, {
            closeButton: true,
            positionClass: 'toast-top',
            preventDuplicates: false,
            rtl: false
          });
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    updateTheme() {
      this.currentTheme = window.localStorage.getItem('AppUiTheme') || 'light';
    },
    setupThemeListener() {
      window.addEventListener('storage', (e) => {
        if (e.key === 'AppUiTheme') {
          this.updateTheme();
        }
      });

      window.addEventListener('themeChanged', () => {
        this.updateTheme();
      });

      this.themeCheckInterval = setInterval(() => {
        const newTheme = window.localStorage.getItem('AppUiTheme') || 'light';
        if (newTheme !== this.currentTheme) {
          this.currentTheme = newTheme;
        }
      }, 100);
    }
  },
  async created() {
    let params = {
      sub_factor_id: this.$route.params.subFactorId
    };
    await onlineFactorService
      .paymentFactor(this.$route.params.hashid, params)
      .then((response) => {
        this.payDetails = response.data.data;
        this.payBtn = this.payDetails.payable;
        this.validateAllFields();
      })
      .catch((error) => {
        throw new Error(error);
      });

    if (this.payment_id) {
      await onlineFactorService.getPayment(this.sub_factor_id, this.payment_id)
          .then(response => {
            this.payment_details = response.data.data
          })
    }

    document.body.scrollTop = 1;
    document.documentElement.scrollTop = 1;

    this.updateTheme();
    this.setupThemeListener();
  },
  beforeDestroy() {
    if (this.themeCheckInterval) {
      clearInterval(this.themeCheckInterval);
    }
    window.removeEventListener('storage', this.updateTheme);
    window.removeEventListener('themeChanged', this.updateTheme);
  },
};
</script>

<style scoped>
ul {
  list-style: none;
}
#factor-payment {
  margin: -7rem 0;
  padding: 0;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #b6fbff,
    #83a4d4
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #b6fbff,
    #83a4d4
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  width: 100%;
  height: max-content;
}
.c_pointer {
  cursor: pointer;
}

#personal_info div {
  margin: 0 1rem;
}

tr:last-child {
  border-bottom: 1px solid #e9e9e9;
}

#cardPaymentData {
  border-radius: 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.light-input, .light-input::placeholder {
  background-color: ghostwhite !important;
  color: gray !important;
  border-color: #8c8a8a !important;
}

@media screen and (max-width: 1000px) {
  .factorpayments {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center;
    margin: 1rem 0;
  }
  table {
    font-size: 9px;
    font-weight: 500;
  }
}
</style>
